module.exports = __webpack_public_path__ + "img/coupon_detail_1@2x.565176ad.svg";